/* eslint-disable no-prototype-builtins */
import { Component } from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';
import { FormGroup, FormLabel } from 'react-bootstrap';
import { actions, Errors } from 'forms/rrf';
import _ from 'lodash';
import hash from 'object-hash';
import PropTypes from 'prop-types';

import '../multi-select.css';

const CaretDropdownIndicator = ({ selectProps }) => (
  <div className="rs__indicator rs__dropdown-indicator">
    <i className={`fa fa-angle-${selectProps.menuIsOpen ? 'up' : 'down'}`}/>
  </div>
);

class RequiredMultiSelect extends Component {
  renderOptions = (values) => {
    const {valueAttr, labelAttr} = this.props;
    if (_.isPlainObject(values)) {
      return (
        Object.keys(values)
          .map(item => ({
            label: values[item],
            value: item
          }))
      );
    }

    return (
      values.map((item) => {
        if (_.isPlainObject(item)) {
          if (item.hasOwnProperty('label') && item.hasOwnProperty('value')) {
            return item;
          }

          return ({
            label: _.get(item, labelAttr),
            value: _.get(item, valueAttr)
          });
        }

        return ({
          label: item,
          value: item
        });
      })
    );
  };

  constructor(props) {
    super(props);

    this.state = {
      value: [],
      options: []
    };

    if (props.model) {
      props.dispatch(actions.setValidity(props.model, false));
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { options, value } = this.state;
    const { model, dispatch, withAllOption } = this.props;

    if (withAllOption && nextProps.data.length) {
      nextProps.data.unshift({
        label: 'All',
        value: 'all'
      });
    }

    let transformedOptions = this.renderOptions(nextProps.data);
    let transformedValue = this.renderOptions(nextProps.value);

    if (withAllOption && value.some(item => item.value === 'all')) {
      transformedOptions = [];
    }

    if (hash(options, {excludeValues: true}) !== hash(transformedOptions, {excludeValues: true}) ||
      hash(value, {excludeValues: true}) !== hash(transformedValue, {excludeValues: true})) {
      if (value.length) {
        transformedValue = value;
      } else if (transformedOptions.length) {
        transformedValue = transformedOptions.filter(val =>
          transformedValue.find(otherVal => val.value.toString() === otherVal.value.toString()));
      }

      this.setState({
        options: transformedOptions,
        value: transformedValue
      });

      if (model) {
        dispatch(actions.change(model, transformedValue));
        dispatch(actions.setValidity(model, transformedValue.length));
        dispatch(actions.setErrors(model, {
          required: !transformedValue.length
        }));
      }
    }
  }

  componentDidMount() {
    const { value, data } = this.props;
    this.UNSAFE_componentWillReceiveProps({
      value,
      data
    });
  }

  handleChange(val) {
    const { model, dispatch } = this.props;

    if (this.props.withAllOption && val.some(item => item.value === 'all')) {
      // eslint-disable-next-line no-param-reassign
      val = val.filter(item => item.value === 'all');
    }

    this.setState({value: val}, () => {
      if (!val.length && model) {
        dispatch(actions.change(model, []));
        dispatch(actions.setValidity(model, false));
        dispatch(actions.setErrors(model, {
          required: true
        }));
      } else if (model) {
        dispatch(actions.change(model, val));
        dispatch(actions.setValidity(model, true));
        dispatch(actions.setErrors(model, {
          required: false
        }));
      }

      if (this.props.onChange && this.props.onChange !== undefined) {
        this.props.onChange(val);
      }
    });
  }

  render() {
    return (
      <FormGroup
        className={`form-group multiselect-formgroup ${this.state.value.length > 0 ? '' : 'has-error'}`}
        controlId={this.props.controlId}
      >
        {this.props.label && (
          <FormLabel>
            {this.props.label}
            *
          </FormLabel>
        )}
        <Select
          components={{ DropdownIndicator: CaretDropdownIndicator }}
          blurInputOnSelect
          className="form-control"
          classNamePrefix="rs"
          isClearable={false}
          closeMenuOnSelect
          isDisabled={this.props.disabled}
          isMulti
          onChange={option => this.handleChange(option)}
          options={this.state.options}
          placeholder={this.props.placeholder}
          isSearchable={this.props.searchable}
          value={this.state.value}
        />

        <Errors
          className="errors"
          messages={this.props.messages || {required: 'This field is required'}}
          model={this.props.model}
          show
        />
      </FormGroup>
    );
  }
}

RequiredMultiSelect.propTypes = {
  model: PropTypes.string,
  label: PropTypes.string,
  data: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object]).isRequired,
  labelAttr: PropTypes.string,
  valueAttr: PropTypes.string,
  controlId: PropTypes.string,
  placeholder: PropTypes.string,
  searchable: PropTypes.bool,
  disabled: PropTypes.any,
  withAllOption: PropTypes.bool,
};

RequiredMultiSelect.defaultProps = {
  labelAttr: 'label',
  valueAttr: 'value',
  controlId: Math.random()
    .toString(16)
    .substring(2),
  searchable: true,
  withAllOption: false
};

export default connect()(RequiredMultiSelect);
